import * as React from "react";
/* empty css                      */
const ClearFacetFilter = ({ onClear, isDisabled = false, label }) => {
  const handleClick = () => {
    onClear();
    const activeFacet = document.getElementById("activeFacet");
    activeFacet?.focus();
  };
  return /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "clear-facet-filter",
      onClick: handleClick,
      disabled: isDisabled,
      type: "button",
      "data-t": "clear-facet-trigger"
    },
    label
  );
};
export {
  ClearFacetFilter,
  ClearFacetFilter as default
};
//# sourceMappingURL=ClearFacetFilter.js.map
